document.addEventListener('DOMContentLoaded', function() {
    if(window.innerWidth < 991) {
        function initMobileShopTheLook() {
            if (typeof Swiper === 'undefined') return;
            var swiper = new Swiper("[mz-js-shop-look]", {
                loop: true,
                navigation: {
                    nextEl: ".mz_popup_next_btn",
                    prevEl: ".mz_popup_prev_btn",
                },
                pagination: {
                  el: ".mz_object-grid__pagination",
                  type: "fraction",
                },
                on: {
                    slideChange: function() {
                        // Check if the active slide is a content block
                        setTimeout(() => {
                            const activeSlide = document.querySelector('.swiper-slide-active');
                            const shopLooksContainer = document.querySelector('.mz_shop-looks');
                            
                            if (activeSlide && activeSlide.classList.contains('mz_content-block-slide')) {
                                shopLooksContainer.classList.add('has-active-content-block');
                            } else {
                                shopLooksContainer.classList.remove('has-active-content-block');
                            }
                        }, 0);
                    },
                    init: function() {
                        // Check on initialization too
                        setTimeout(() => {
                            const activeSlide = document.querySelector('.swiper-slide-active');
                            const shopLooksContainer = document.querySelector('.mz_shop-looks');
                            
                            if (activeSlide && activeSlide.classList.contains('mz_content-block-slide')) {
                                shopLooksContainer.classList.add('has-active-content-block');
                            } else {
                                shopLooksContainer.classList.remove('has-active-content-block');
                            }
                        }, 0);
                    }
                }
            });
            new Swiper("[mz-js-swiper-slider-mobile]", {
                slidesPerView: 2.6,
                spaceBetween: 10,
            });
        }

        initMobileShopTheLook()
        document.addEventListener('STL:mobileSliderInit', (e) => initMobileShopTheLook())
    }

    function quickAddToCart(variantID) {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        let formData = {
            'items': [{
                "id": variantID,
                "quantity": 1
            }]
        };

        if (cart) {
            formData.sections = cart.getSectionsToRender().map((section) => section.id);
            formData.sections_url = window.location.pathname;
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(function(response) {
            if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                    source: 'shop-the-look',
                    productVariantId: variantID,
                    errors: response.description,
                    message: response.message
                });
                // return;
            }

            if (!cart) {
                window.location = window.routes.cart_url;
                return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'shop-the-look',
                cartData: response,
                productVariantId: variantID
            });

            cart.renderContents(response);
            
            // Handle drawer visibility and classes
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
                cartDrawer.classList.remove('is-empty');
                const drawerFooter = cartDrawer.querySelector('.drawer__footer');
                if (drawerFooter) {
                    drawerFooter.classList.remove('hidden');
                }
            }
        })
        .catch((error) => {
            console.error('Error:', error);
            publish(PUB_SUB_EVENTS.cartError, {
                source: 'shop-the-look',
                productVariantId: variantID,
                errors: error.message,
                message: error.message
            });
        });
    }

    const products = document.querySelectorAll('[js-variant-option-selector]')
    products.forEach(prod => {
        prod.addEventListener('click', function(e) {
            e.preventDefault();
            if (prod.closest('.mz_popup__size--wrap')) 
                prod.closest('.mz_popup__size--wrap').classList.remove('open');

            quickAddToCart(prod.dataset.variant);
        })
    });

    function STLItemPopupInit() {

        // item popups 
        const productItems = document.querySelectorAll('[js-shop-the-look-item]')
        
        const shopTheLookContainer = document.querySelector('.mz_shop-looks')
        const shopTheLookSectionId = shopTheLookContainer.dataset.sectionId
        console.log("stl item popup function");

        productItems && productItems.forEach((item, index) => {
            item.addEventListener('click', function(e) {
                const { currentTarget } = e
                const dataIndex = currentTarget?.dataset.itemIndex

                if(window.innerWidth > 990) {
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    })
                    const itemsListContainer = currentTarget.closest('.looks__items--container')
    
                    if (document.body.classList.contains('template--collection')) {
                        document.body.classList.add('clc-shop-the-look')
                    }
                    document.querySelector('[js-shop-the-looks-popup]').classList.remove('hidden')
                    
                    
                    itemsListContainer.classList.add('hidden')
                    const index_ = Number(dataIndex) - 1;

                    try {
                        document.querySelector('[mz-js-swiper-slider-thumb]').swiper.destroy();
                        document.querySelector('[mz-js-swiper-slider]').swiper.destroy();
                    } catch (error) {
                        console.log('error', error);
                    }

                    // slider init
                    if (typeof Swiper !== 'undefined') {
                    var thumbsSlider = new Swiper("[mz-js-swiper-slider-thumb]", {
                        slidesPerView: 'auto',
                        speed: 0,
                        autoHeight: true,
                        watchSlidesProgress: true,
                        effect: 'fade',
                        allowTouchMove: false,
                        simulateTouch: false,
                    });

                    var mainSlider = new Swiper("[mz-js-swiper-slider]", {
                        loop: true,
                        autoHeight: true,
                        watchSlidesVisibility: true,
                        watchSlidesProgress: true,
                        navigation: {
                        nextEl: ".mz_popup_next_btn",
                        prevEl: ".mz_popup_prev_btn",
                        },
                        pagination: {
                            el: ".mz_slider_pagination",
                            type: "fraction",
                        },
                    });

                    mainSlider.on('slideChange', function () {
                        thumbsSlider.slideTo(mainSlider.realIndex, 0);
                    });

                    thumbsSlider.slideTo(index_, 0)
                    mainSlider.slideTo(index_, 0)
                    }
                } else {
                    const popupsContainer = document.querySelector('[js-mobile-shop-the-look-popup]')
                    const mobileContents = popupsContainer.querySelectorAll('[js-shop-the-look-content]')

                    popupsContainer.classList.remove('in-active')
                    popupsContainer.classList.add('active')

                    const itemConainers = popupsContainer.querySelectorAll('.mz_popup__product--row');
                    itemConainers.forEach((item) => {
                        if (item.dataset.itemIndex == dataIndex) {
                            item.classList.remove('hidden')
                        } else {
                            item.classList.add('hidden')
                        }
                    });
                }

                // Mobile Shop The Look Popup
                const overlay = document.querySelector('.looks__content-container .overlay__elm')
                overlay.addEventListener('click', function() {
                    const mobileContainer = document.querySelector('[js-mobile-shop-the-look-popup]')
                    if(!mobileContainer.classList.contains('in-active')) {
                        mobileContainer.classList.add('in-active')
                        mobileContainer.classList.remove('active')

                        const itemsContainer = mobileContainer.querySelectorAll('.mz_popup__product--row')

                        itemsContainer.forEach(item => {
                            item.classList.add('hidden')
                        })
                    }
                });
            })
        })

        const backButton = document.querySelector('[js-shop-the-look-back-button].desktop')
        backButton.addEventListener('click', function() {
            if (document.body.classList.contains('clc-shop-the-look')) {
                document.body.classList.remove('clc-shop-the-look')
            }
            const itemsListContainer = document.querySelector('.looks__items--container.hidden')
            document.querySelector('[js-shop-the-looks-popup]').classList.add('hidden')
            itemsListContainer.classList.remove('hidden')
        });

        const sizePlusIcons = document.querySelectorAll('.mz_popup__plus--icon:not([js-variant-option-selector])');
        sizePlusIcons.forEach((icon) => {
            icon.addEventListener('click', (event) => {
                event.preventDefault();
                icon.closest('.mz_popup__size--wrap').classList.add('open');
            });
        });

        const sizeCloseIcons = document.querySelectorAll('.mz_popup__close--icon');
        sizeCloseIcons.forEach((icon) => {
            icon.addEventListener('click', (event) => {
                event.preventDefault();
                icon.closest('.mz_popup__size--wrap').classList.remove('open');
            });
        });
    }

    STLItemPopupInit()
    document.addEventListener('STL:ItemPopupInit', (e) => STLItemPopupInit())

    // mobile shop the look button to open the looks popup
    const mobileButton = document.querySelector('.mz_shop-look-popup__view--text.mobile__btn')
    if (mobileButton) {
        mobileButton.addEventListener('click', (e) => {
            const activeSlide = document.querySelector('.mz_object-grid__item.swiper-slide-active');
            if (activeSlide) {
                const productWrapper = activeSlide.querySelector('.mz_object-grid__item--wrap');
                if (productWrapper) {
                    productWrapper.click()
                }
            }
        })
    }
})